import { createApiRequest } from "../common";
import { CreateOrgRequestContent, CreateOrgResponseContent } from '@equaliq/api-model';

export const createOrgApi = async (request: CreateOrgRequestContent): Promise<CreateOrgResponseContent> => {
  const apiRequest = createApiRequest<CreateOrgResponseContent>('post', '/orgs/create');
  return apiRequest(request);
};
